// packages/content/src/catalog/index.ts
import { catalogModules } from '../catalog.gen';
import type { CatalogEntry, ItemEntry, WorldEntry } from '../schema/catalog';
import type { ItemKind } from '../schema/domain';
import type { CatalogId } from '../schema/ids';

export function buildCatalog(modules: Readonly<Record<string, readonly CatalogEntry[]>>): ReadonlyMap<CatalogId, CatalogEntry> {
  const map = new Map<CatalogId, CatalogEntry>();
  for (const entries of Object.values(modules)) for (const e of entries) {
    if (map.has(e.id)) throw new Error(`duplicate catalog id ${e.id}`);
    map.set(e.id, e);
  }
  return map;
}
export const CATALOG: ReadonlyMap<CatalogId, CatalogEntry> = buildCatalog(catalogModules as Readonly<Record<string, readonly CatalogEntry[]>>);
export function isItemEntry(e: CatalogEntry): e is ItemEntry { return e.kind !== 'world'; }
export function getEntry(id: CatalogId): CatalogEntry | undefined { return CATALOG.get(id); }
export function getItem(id: CatalogId): ItemEntry {
  const e = CATALOG.get(id);
  if (!e || !isItemEntry(e)) throw new Error(`not an item: ${id}`);
  return e;
}
export function itemsOfKind<K extends ItemKind>(kind: K): readonly Extract<ItemEntry, { kind: K }>[] {
  return [...CATALOG.values()].filter((e): e is Extract<ItemEntry, { kind: K }> => e.kind === kind);
}
export function worldEntries(): readonly WorldEntry[] {
  return [...CATALOG.values()].filter((e): e is WorldEntry => e.kind === 'world');
}
